import { ChangeDetectionStrategy, Component, inject, OnInit, signal } from '@angular/core';
import { RouterLink } from '@angular/router';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';

import { AuthService } from '../../../../core/auth/auth.service';

@Component({
  selector: 'app-reset-password-email-sent',
  imports: [RouterLink, MatButtonModule, MatCardModule, MatProgressSpinnerModule],
  templateUrl: './email-sent.html',
  styleUrl: './email-sent.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ResetPasswordEmailSentComponent implements OnInit {
  private readonly authService = inject(AuthService);

  protected readonly sentEmail = signal<string>('');
  protected readonly resendState = signal<'idle' | 'loading' | 'sent'>('idle');

  ngOnInit(): void {
    const state = history.state as { email?: string };
    if (state?.email) this.sentEmail.set(state.email);
  }

  protected onResend(): void {
    if (this.resendState() === 'loading' || !this.sentEmail()) return;
    this.resendState.set('loading');
    this.authService.requestPasswordReset(this.sentEmail()).subscribe({
      next: () => this.resendState.set('sent'),
      error: () => this.resendState.set('sent'),
    });
  }
}
